import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { CardStateProvider } from './state/CardState';
import { DisplayPrefsProvider } from './state/DisplayPrefs';
import { ProgressProvider } from './state/Progress';
import { ThemeProvider } from './state/Theme';
import { VoicePrefsProvider } from './state/Voices';
import './styles/index.css';
import './styles/theme.css';
import './styles/global.css';

const root = document.getElementById('root');
if (!root) throw new Error('No #root element');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <VoicePrefsProvider>
          <DisplayPrefsProvider>
            <ProgressProvider>
              <CardStateProvider>
                <App />
              </CardStateProvider>
            </ProgressProvider>
          </DisplayPrefsProvider>
        </VoicePrefsProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
);
